import styled from "styled-components";
import {Link} from "react-router-dom";

export const Container = styled.div`
  width: 100%;
  padding: 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    padding: 70px 100px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 130px 200px;
  }
`

export const View = styled.div`
  display: none;

  @media only screen and (${({theme}) => theme.media.large}) {
    display: block;
  }
`

export const SmallView = styled.div`
  display: block;

  @media only screen and (${({theme}) => theme.media.large}) {
    display: none;
  }
`

export const Title1 = styled.h3`
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: uppercase;
  margin-bottom: 20px;
  color: ${({theme}) => theme.business.colors.titleColor};

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 28px;
    line-height: 50px;
    font-weight: 600;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 32px;
    line-height: 60px;
    margin-bottom: 50px;
  }
`

export const Title2 = styled.h2`
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0;
  text-align: center;
  color: ${({theme}) => theme.business.colors.titleColor};

  @media only screen and (${({theme}) => theme.media.large}) {
    text-align: left;
    font-size: 40px;
    font-weight: 600;
    line-height: 54px;
  }
`

export const Text1 = styled.div`
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  letter-spacing: 0;
  margin-bottom: 10px;
  color: ${({theme}) => theme.business.colors.textColor};

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 40px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
    margin-bottom: 20px;
  }
`

export const InnerLink = styled(Link)`
  color: ${({theme}) => theme.business.colors.primary};

  &:hover {
    color: ${({theme}) => theme.business.colors.primary};
    text-decoration-line: underline;
  }
`

export const OuterLink = styled.a`
  color: ${({theme}) => theme.colors.red};

  &:hover {
    color: ${({theme}) => theme.colors.darkRed};
    text-decoration-line: underline;
  }
`